/**
 * Design tokens — single source of truth for visual constants.
 * Consumed by packages/ui components and apps/website global styles.
 * No page content or business copy lives here.
 */
export const themeTokens = {
  colors: {
    background: '#ffffff',
    surface: '#f5f6f8',
    border: '#e2e5ea',
    textPrimary: '#12181f',
    textSecondary: '#4a5568',
    // Deep "Rolex green" — primary brand color (was navy #0f2440).
    brandPrimary: '#0b3d2e',
    // Slightly darker green for hover/active states on primary elements.
    brandPrimaryDark: '#072a20',
    // Brushed gold — accent color, used sparingly (CTAs, highlights, icons).
    brandAccent: '#c9a24b',
    // Darker gold for hover/active states on accent elements.
    brandAccentDark: '#a8843a',
    // Near-black surface for dark sections (footer, dark hero overlays, etc.).
    surfaceDark: '#0d0d0d',
    // Text color for use on dark/green/black surfaces.
    textOnDark: '#f5f5f0'
  },
  typography: {
    fontFamilyBase: "'Vazirmatn', system-ui, sans-serif",
    fontSizeBase: '16px',
    lineHeightBase: 1.6
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '40px'
  },
  radii: {
    sm: '4px',
    md: '8px',
    lg: '16px'
  },
  breakpoints: {
    sm: '480px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
  }
} as const;

export type ThemeTokens = typeof themeTokens;
